import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import useFeatureAccess from "@app/common/hooks/useFeatureAccess";
import useLocalStorage from "@app/common/hooks/useLocalStorage";
import ROUTES from "@app/common/routes";
import { pluralize, pluralizePhrase } from "@app/common/utils";
import useWorkspace from "@app/common/workspaces/useWorkspace";

import Alert from "@rui/Alert";
import Link from "@rui/Link";
import { Bold } from "@rui/styles";

const EmptySeatsAlert = () => {
  const { inWorkspace, workspaceId } = useWorkspace();
  const { licenses } = useBillingContext();
  const { canInviteUsers } = useFeatureAccess();

  const [dismissed, setDismissed] = useLocalStorage(
    "unusedLicenseAlertDismissed",
    false,
    { migrateKeys: true }
  );

  const showAlert =
    !dismissed &&
    licenses.numUnclaimed > 0 &&
    ((inWorkspace && canInviteUsers) || !inWorkspace);

  if (!showAlert) return null;

  return (
    <Alert severity="warning" dismissible onDismiss={() => setDismissed(true)}>
      You have{" "}
      <Bold>{pluralizePhrase(licenses.numUnclaimed, "unused license")}</Bold>
      {inWorkspace ? " in your Workspace. " : ". "}
      {inWorkspace ? (
        <Link to={ROUTES.workspaceSettingsPeopleById(workspaceId!)}>
          Invite {pluralize("a member", "members", licenses.numUnclaimed)}
        </Link>
      ) : (
        <>
          <Link to={ROUTES.NEW_WORKSPACE}>Create a Workspace</Link> and invite
          people
        </>
      )}{" "}
      to use your {pluralize("license", licenses.numUnclaimed)}!
    </Alert>
  );
};

export default EmptySeatsAlert;
